import DataTable from '@/containers/data_table_ml/DataTable';
import { keepDecimal } from '../../../../../../utils/comUtil';

const TablePage = (props) => {
  const { tableData, inOutPut } = props || {};
  const columns =
    inOutPut === 'in'
      ? [
          {
            title: '输入字段',
            dataIndex: 'field',
            key: 'field',
            // width: 100,
          },
          {
            title: '输入值',
            dataIndex: 'value',
            key: 'value',
            // width: 100,
            render: (record) => {
              return keepDecimal(record, 2);
            },
          },
        ]
      : [
          {
            title: '输出字段',
            dataIndex: 'field',
            key: 'field',
            // width: 100,
          },
          {
            title: '输出项',
            dataIndex: 'value',
            key: 'value',
            // width: 100,
          },
        ];
  return (
    <div className="operateLog">
      <DataTable
        className="demo-test"
        columns={columns}
        rowSelection={false}
        dataSource={tableData}
        changePage={(a) => {
          props.pageNumChange(a);
        }}
        changePageSize={(a) => {
          props.pageSizeChange(a);
        }}
      />
    </div>
  );
};
export default TablePage;
